import React from 'react'
import { AiFillCheckCircle } from 'react-icons/ai';
import { BiToggleLeft, BiToggleRight } from 'react-icons/bi'


const BudgetSchedule: React.FC = () => {
  const [toggleSwitches, setToggleSwitches] = React.useState(false);
  

  return (
    <>
      <div className="flex justify-center bg-white rounded-lg p-8 flex-col shadow-[0px_4px_16px_0px_rgba(24,119,242,0.08)] gap-2">
        <div className="flex justify-between items-center">
          <h3 className="font-semibold text-lg text-[#555]">Dynamic creative</h3>
          <div className="flex gap-2 items-center">
            <h3 className='text-[#555] text-base font-semibold'>{!toggleSwitches ? 'Off' : 'On'}</h3>
            {!toggleSwitches
              ?
              <BiToggleRight
                size={24}
                className='text-[#CCC] cursor-pointer'
                onClick={() => setToggleSwitches(!toggleSwitches)} />

              :
              <BiToggleLeft
                size={24}
                className='cursor-pointer'
                onClick={() => setToggleSwitches(!toggleSwitches)} />}
          </div>
        </div>
        <p className='text-[#727272] text-sm font-normal mt-2'>
          Provide creative elements, such as images and headlines, and we’ll automatically generate combinations optimized
          for your audience. Variations may include different formats, templates or audio based on one or more elements.<br />
          <span className='text-xs text-midGreen'>Learn more</span>
        </p>
      </div>

      <div className="flex justify-center text-[#555] bg-white rounded-lg mt-10 p-8 pb-10 flex-col gap-8 shadow-[0px_4px_16px_0px_rgba(24,119,242,0.08)]">
        <div className="flex gap-2 items-center">
          <AiFillCheckCircle className='fill-green-500' />
          <h1 className='font-semibold text-lg'>Budget & schedule</h1>
        </div>

        <div className="grid gap-1">
          <h1 className='font-semibold text-base'>Start Date</h1>
          <div 
            className="flex justify-between"
          >
            <input 
              type="date"
              placeholder='Jun 13, 2023'
              id='form1'
              className='w-[49%] h-11 pl-5 py-3 outline-none border-[#CCC] border-solid border rounded-lg placeholder:text-[#CCC] placeholder:font-Poppins placeholder:font-normal placeholder:text-xs' 
            />
            <div className="w-[49%]">
              <input 
                type="time"
                placeholder='4:18pm'
                className='w-full h-11 pl-5 py-3 outline-none border-[#CCC] border-solid border rounded-lg' 
              />
              <h2 className='text-xs text-[#727272] font-normal mt-1'>Eastern Time</h2>
            </div>
            
          </div>
        </div>

        <div className="grid gap-1 mt-11">
          <h1 className='font-semibold text-base'>End Date</h1>
          <div 
            className="flex justify-between"
          >
            <input 
              type="date"
              placeholder='Jun 13, 2023'
              className='w-[49%] h-11 pl-5 py-3 outline-none border-[#CCC] border-solid border rounded-lg placeholder:text-[#CCC] placeholder:font-Poppins placeholder:font-normal placeholder:text-xs' 
            />
            <div className="grid w-[49%]">
              <input 
                type="time"
                placeholder='4:18pm'
                className='w-full h-11 pl-5 py-3 outline-none border-[#CCC] border-solid border rounded-lg' 
              />
              <h2 className='text-xs text-[#727272] font-normal mt-1'>Eastern Time</h2>
            </div>
          </div>
        </div>
        <div className="grid gap-1 mt-11">
          <h1 className='font-semibold text-base'>Time Zone</h1>
          <input 
            type="text"
            placeholder='Use viewer’s time zone'
            className='w-full h-11 pl-5 py-3 outline-none border-[#CCC] border-solid border rounded-lg placeholder:text-[#CCC] placeholder:font-Poppins placeholder:font-normal placeholder:text-xs' 
          />
          <p className='text-xs text-[#727272] font-normal mt-1'>
            We’ll schedule your ads based on the time zone
            of the person seeing it. For example, 
            if you select 8am to 5pm, we’ll only show your ads to
            people from 8am to 5pm in their local time.
          </p>
        </div>
      </div>
    </>
  )
}

export default BudgetSchedule